import React from 'react';
import { Spin, Alert } from 'antd';

const Loading: React.FC<{ title: string; subtitle?: string }> = ({
  title,
  subtitle,
}) => {
  return (
    <Spin tip={title} style={{ position: 'absolute', top: 100, left: 100 }}>
      <Alert message={subtitle} type="info" />
    </Spin>
  );
};

export default Loading;
